<template>
  <div class="loginStatus-box-outer">
    <div v-if="!user.avatar" class="login">
      <router-link key="login" to="/login" class="text"> 登录 </router-link> |
      <router-link key="register" to="/register" class="text register">
        注册
      </router-link>
    </div>
    <div class="avatar-box" v-else>
      <el-avatar
        class="e-avatar"
        :src="user.avatar"
        @click="show = true"
      ></el-avatar>
    </div>
  </div>
  <vanOverlay :show="show" @click="show = false" :z-index="1111">
    <div class="menu_wrapper" @click.stop>
      <div class="menu_top">
        <img
          src="@/assets/images/common/close.png"
          class="closeBtn"
          @click="show = false"
        />
        <el-avatar class="e-avatar" :src="user.avatar"></el-avatar>
        <div class="vipBox">
          <div class="menu_nickname">{{ user.nickname }}</div>
          <img
            class="vip"
            v-if="user.is_vip == '1'"
            src="@/assets/images/common/vip.png"
          />
        </div>
      </div>
      <div class="menu_btm">
        <div class="menu_bar">
          <sideBar />
        </div>
        <div class="menu_loginOut">
          <vanButton type="default" round block @click="loginOut"
            >退出登录</vanButton
          >
        </div>
      </div>
    </div>
  </vanOverlay>
</template>
      
<script lang="ts">
import { onBeforeMount, defineComponent, ref, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";
import sideBar from "@/components/mine/sideBar.vue";
import { Overlay, Button, Dialog } from "vant";
import { ElMessageBox, ElMessage } from "element-plus";

export default defineComponent({
  name: "phoneLogin",
  components: {
    sideBar,
    vanOverlay: Overlay,
    vanButton: Button,
    [Dialog.Component.name]: Dialog.Component,
  },
  setup() {
    const user = ref<any>({});
    onBeforeMount(() => {
      user.value = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo") as string)
        : {};
    });
    const router = useRouter();
    const route = useRoute();
    const show = ref(false);
    const showPopup = () => {
      show.value = true;
    };
    const loginOut = (): void => {
      Dialog.confirm({
        message: "您确定要退出登录么？",
        className: "loginOut",
        confirmButtonColor: "#999999",
      })
        .then(() => {
          localStorage.removeItem("authorization");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("expirationTime");
          ElMessage({
            type: "success",
            message: "退出成功！",
          });
          if (
            location.origin == "https://pay2.diancang.site" ||
            location.origin == "https://zhishiquan.online"
          ) {
            location.href = "/official-web/";
          } else {
            location.href = "/";
          }
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "取消退出！",
          });
        });
    };
    watchEffect(() => {
      if (route.name) {
        show.value = false;
      }
    });
    return {
      user,
      show,
      showPopup,
      loginOut,
    };
  },
});
</script>
<style  lang="scss">
.info-bar .sideBar-index .el-menu-item.is-active::before {
  display: none !important;
}
.avatar-box {
  .el-avatar--default {
    --el-avatar-size: 0.6rem;
  }
}
.menu_bar {
  .sideBar-index {
    .el-menu {
      background: transparent;
      .el-menu-item {
        text-align: left;
        padding-left: 0.7rem !important;
        box-sizing: border-box;
        font-size: 0.32rem;
        color: #fafafa;
        &:hover {
          background: none;
        }
      }
      .el-menu-item.is-active {
        color: #ffca28;
      }
    }
  }
}
.menu_loginOut {
  .van-button {
    width: 3.4rem;
    height: 0.88rem;
    line-height: 0.44rem;
    background: transparent;
    margin: 0 auto;
    .van-button__text {
      color: #fafafa;
    }
  }
}
.loginOut.van-popup {
  width: 70%;
  top: 45%;
  left: 50%;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  .van-dialog__content--isolated {
    min-height: 60px;
  }
}
</style>
<style  lang="scss" scoped>
.loginStatus-box-outer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 0.28rem;
  color: #fafafa;

  .login {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text {
    font-weight: 400;
    color: #fafafa;

    text-decoration: none;
    margin: 0 5px;
  }
  .avatar-box {
    display: flex;
    align-items: center;
  }
}

.menu_wrapper {
  width: 58%;
  background: #363c58;
  height: 100%;
  position: fixed;
  z-index: 22222;
  right: 0;
  .menu_top {
    height: 2.4rem;
    background: #25293a;
    padding: 1.1rem 0.4rem 0.2rem;
    box-sizing: border-box;
    display: flex;
    position: relative;
    .el-avatar--default {
      --el-avatar-size: 0.88rem;
    }
    .vipBox {
      margin-left: 0.2rem;
      .menu_nickname {
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #fafafa;
      }
      .vip {
        width: 0.8rem;
        margin-top: 0.1rem;
      }
    }

    .closeBtn {
      position: absolute;
      right: 0.3rem;
      top: 0.3rem;
      width: 0.3rem;
    }
  }
}
</style>